import React from "react";

import { Text } from "@performyard/py-components";

import { GeneratedContentContainer } from "./GeneratedContentContainer";
import { ImprovementCard, type ImprovementCardState } from "./ImprovementCard";

type ImprovementsContainerProps = {
	suggestionStates: ImprovementCardState[];
	onApply: (suggestionId: string) => void;
	// Still passed by ChatMessage; per-card dismissal was dropped in the 167:34992 redesign, so it's unused.
	onDelete?: (suggestionId: string) => void;
	/** Whether the page this panel is open on can actually take the change right now (PY-14326). */
	canApply: boolean;
};

/** "Suggested Improvements" block shared by the goal and form building coaches. */
export const ImprovementsContainer: React.FC<ImprovementsContainerProps> = ({
	suggestionStates,
	onApply,
	canApply,
}) => {
	const visibleSuggestions = suggestionStates.filter((s) => s.status !== "deleted");
	const allRemoved = visibleSuggestions.length === 0;

	return (
		<GeneratedContentContainer>
			{allRemoved ? (
				<Text size="paragraph-3" color="neutral-7">
					All suggested improvements have been removed.
				</Text>
			) : (
				<div className="flex flex-col gap-3">
					{visibleSuggestions.map((s) => (
						<ImprovementCard
							key={s.suggestion.id}
							suggestionState={s}
							onApply={() => onApply(s.suggestion.id)}
							canApply={canApply}
						/>
					))}
				</div>
			)}
		</GeneratedContentContainer>
	);
};

export default ImprovementsContainer;
